import request from 'utils/request';

const PREFIX = '/api/aff/hedge/app/';

export const AffHedgeAppAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  AUDIT: PREFIX + 'audit',
  PREVIEW: PREFIX + 'preview',
  AUTO_PAT: PREFIX + 'auto-pay/',
  COMPANY_INFO_NUMBERS: PREFIX + 'company-info/numbers',
};

export function getAffHedgeAppList(data) {
  return request({
    url: AffHedgeAppAPI.LIST,
    method: 'post',
    data,
  });
}

export function addAffHedgeApp(data) {
  return request({
    url: AffHedgeAppAPI.ADD,
    method: 'post',
    data,
  });
}

export function auditAffHedgeAppStatus(data) {
  return request({
    url: AffHedgeAppAPI.AUDIT,
    method: 'post',
    data,
  });
}

export function getAffHedgeAppPreviewData(data) {
  return request({
    url: AffHedgeAppAPI.PREVIEW,
    method: 'post',
    data,
  });
}

export function getCompanyInfoNumbers(data) {
  return request({
    url: AffHedgeAppAPI.COMPANY_INFO_NUMBERS,
    method: 'post',
    data,
  });
}

export function affPaymentAutoPayProcess(affHedgeAppNumber) {
  return request({
    url: AffHedgeAppAPI.AUTO_PAT + affHedgeAppNumber,
    method: 'get',
  });
}
